var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHexagons01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 212.28 598.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}.cls-6{fill:url(#linear-gradient-6);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -2350.03,
    y1: -5307.05,
    x2: -1766.18,
    y2: -5307.05,
    gradientTransform: "matrix(0, 1, 1, 0, 5671.35, 2547.06)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#0682b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006391"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -2265.31,
    y1: -5307.05,
    x2: -2352.06,
    y2: -5307.05,
    gradientTransform: "matrix(0, 1, 1, 0, 5671.35, 2547.06)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18c3fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009de6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -2363.04,
    y1: -5451.05,
    x2: -1913.63,
    y2: -5451.05,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -2297.83,
    y1: -5451.05,
    x2: -2364.6,
    y2: -5451.05,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -2358.67,
    y1: -5378.05,
    x2: -1928.06,
    y2: -5378.05,
    gradientTransform: "matrix(0, 1, 1, 0, 5671.35, 2547.06)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#067eb2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006391"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -2331.89,
    y1: -5378.05,
    x2: -2364.06,
    y2: -5378.05,
    xlinkHref: "#linear-gradient-2"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "hexagons01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Front"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_7",
    "data-name": "Layer 7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M368.12,779.84,399.06,762a7.66,7.66,0,0,0,3.82-6.62V222.54a7.67,7.67,0,0,0-3.82-6.62L368.12,198a7.71,7.71,0,0,0-7.64,0l-30.94,17.88a7.67,7.67,0,0,0-3.82,6.62V755.37a7.66,7.66,0,0,0,3.82,6.62l30.94,17.85A7.57,7.57,0,0,0,368.12,779.84Z",
    transform: "translate(-190.6 -182.45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M368.12,280.71l30.94-17.85a7.64,7.64,0,0,0,3.82-6.62V220.51a7.64,7.64,0,0,0-3.82-6.61L368.12,196a7.71,7.71,0,0,0-7.64,0L329.54,213.9a7.64,7.64,0,0,0-3.82,6.61v35.73a7.64,7.64,0,0,0,3.82,6.62l30.94,17.85A7.57,7.57,0,0,0,368.12,280.71Z",
    transform: "translate(-190.6 -182.45)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M223.24,632.63l23.82-13.74a5.9,5.9,0,0,0,2.94-5.1V203.65a5.88,5.88,0,0,0-2.94-5.09l-23.82-13.77a5.93,5.93,0,0,0-5.88,0l-23.82,13.77a5.88,5.88,0,0,0-2.94,5.09V613.79a5.9,5.9,0,0,0,2.94,5.1l23.82,13.74A5.83,5.83,0,0,0,223.24,632.63Z",
    transform: "translate(-190.6 -182.45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M223.24,248.43l23.82-13.74a5.89,5.89,0,0,0,2.94-5.1v-27.5a5.87,5.87,0,0,0-2.94-5.09l-23.82-13.77a5.93,5.93,0,0,0-5.88,0L193.54,197a5.87,5.87,0,0,0-2.94,5.09v27.5a5.89,5.89,0,0,0,2.94,5.1l23.82,13.74A5.83,5.83,0,0,0,223.24,248.43Z",
    transform: "translate(-190.6 -182.45)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_5",
    "data-name": "Layer 5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M294.72,618.3l11.46-8.11a6.88,6.88,0,0,0,1.42-4.54V205.87a6.87,6.87,0,0,0-1.42-4.53l-11.46-12.25a1.78,1.78,0,0,0-2.84,0l-11.46,12.25a6.87,6.87,0,0,0-1.42,4.53V605.65a6.88,6.88,0,0,0,1.42,4.54l11.46,8.11A1.79,1.79,0,0,0,294.72,618.3Z",
    transform: "translate(-190.6 -182.45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M294.72,214.79l11.46-6.63a2.82,2.82,0,0,0,1.42-2.46V192.47a2.89,2.89,0,0,0-1.42-2.47l-11.46-6.62a2.83,2.83,0,0,0-2.84,0L280.42,190a2.83,2.83,0,0,0-1.42,2.47V205.7a2.87,2.87,0,0,0,1.42,2.46l11.46,6.63A2.88,2.88,0,0,0,294.72,214.79Z",
    transform: "translate(-190.6 -182.45)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagons01);
export default __webpack_public_path__ + "static/media/hexagons01.b10f15cf54970a85d4291f6202a368d8.svg";
export { ForwardRef as ReactComponent };